import React from 'react';
import { ShieldAlert, CheckCircle, Handshake, MessageCircle, RefreshCw } from 'lucide-react';
const guarantees = [{
  icon: DollarSign,
  promise: 'Solo $125 para empezar',
  meaning: 'No arriesgas todo tu dinero desde el principio'
}, {
  icon: Eye,
  promise: 'Ves el resultado antes del pago final',
  meaning: 'Apruebas el diseño antes de pagar el resto'
}, {
  icon: RefreshCw,
  promise: 'Revisiones incluidas',
  meaning: 'No paramos hasta que lo ames'
}, {
  icon: Handshake,
  promise: 'Proceso transparente',
  meaning: 'Sabes exactamente qué está pasando en cada etapa'
}, {
  icon: MessageCircle,
  promise: 'Comunicación directa por WhatsApp',
  meaning: 'Respuestas rápidas, sin intermediarios'
}, {
  icon: ShieldAlert,
  promise: 'Sin mensualidades forzadas',
  meaning: 'Pagas el mantenimiento solo si lo quieres'
}];
// Need to import DollarSign and Eye since I used them in the array
import { DollarSign, Eye } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-24 bg-dark relative" data-id="element-152" data-mp="20su412tqqnr0">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-153" data-mp="20s2kwrhbyihm">
        <div className="text-center mb-16" data-id="element-154" data-mp="1vt7p8oy9kzg3">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 mb-6" data-id="element-155" data-mp="1vu9b7ogtj6cl">
            <ShieldAlert className="w-8 h-8 text-gold" data-id="element-156" data-mp="1rtyvvl74z3l2" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-157" data-mp="2oh3jzo49wha8">
            Cero Riesgo. 100% Satisfacción. <br className="hidden md:block" data-id="element-158" data-mp="2jkmzr5072n2f" />
            <span className="text-gold" data-id="element-159" data-mp="2eslmpgv7csbc">O Lo Corregimos.</span>
          </h2>
          <div className="text-lg text-gray-400 max-w-2xl mx-auto space-y-4" data-id="element-160" data-mp="2eqiowant5uw2">
            <p data-id="element-161" data-mp="2aqiaur4mflpj">Sabemos que probablemente te han fallado antes.</p>
            <p data-id="element-162" data-mp="37964xbny6jqa">
              Tal vez alguien te hizo un website que no se parecía en nada a lo
              que querías. Tal vez pagaste y nunca viste resultados.
            </p>
            <p className="text-white font-bold" data-id="element-163" data-mp="10kxfzwuzqxxd">Así no operamos nosotros.</p>
          </div>
        </div>

        <div className="bg-dark-100 rounded-3xl border border-white/10 p-8 md:p-12 shadow-2xl" data-id="element-164" data-mp="15jgzzrq0xzn3">
          <h3 className="text-2xl font-bold text-center text-white mb-10" data-id="element-165" data-mp="qv41amzjy2ow">
            Nuestra Garantía:
          </h3>

          <div className="grid md:grid-cols-2 gap-x-12 gap-y-8" data-id="element-166" data-mp="vt5ptnfqyu7r">
            {guarantees.map((item, index) => <div key={index} className="flex items-start gap-4" data-id="element-167" data-mp="htd0nwjvcm1w" data-mpi={index}>
                <div className="bg-dark p-3 rounded-xl border border-white/5 shrink-0" data-id="element-168" data-mp="mtscgjoi5lhr">
                  <item.icon className="w-6 h-6 text-gold" data-id="element-169" data-mp="7w8c5q2jwehx" />
                </div>
                <div data-id="element-170" data-mp="7ycp0xifgnuc">
                  <h4 className="text-white font-bold mb-1" data-id="element-171" data-mp="cujk1v9acexi">{item.promise}</h4>
                  <p className="text-gray-400 text-sm" data-id="element-172" data-mp="229ztlbr4g2nx">{item.meaning}</p>
                </div>
              </div>)}
          </div>

          <div className="mt-12 pt-8 border-t border-white/10 text-center" data-id="element-173" data-mp="2781cnwojs1ze">
            <p className="text-xl font-bold text-white" data-id="element-174" data-mp="3rqlk98ffvr4o">
              No das el pago final hasta que estés{' '}
              <span className="text-gold" data-id="element-175" data-mp="3mstlbugdn4qz">100% satisfecho</span> con tu website.
            </p>
          </div>
        </div>
      </div>
    </section>;
}